var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "playlist__grids" }, [
    _c(
      "div",
      { staticClass: "playlist__grid-1 child-is-overlay" },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: _vm.$_gridImages[0] }
        }),
        _vm._v(" "),
        !_vm.$_hasImage ? _vm._t("empty") : _vm._e(),
        _vm._v(" "),
        _vm._t("main")
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "playlist__grid-1 child-is-overlay" },
      [
        _c("div", { staticClass: "playlist__grid-1-1" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: { src: _vm.$_gridImages[1] }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "playlist__grid-1-1" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: { src: _vm.$_gridImages[2] }
          })
        ]),
        _vm._v(" "),
        _vm._t("side")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }